import React, { FC } from 'react'

type IinePointIconProps = {
  size?: 'sm' | 'md'
  additionalClassName?: string
}

export const IinePointIcon: FC<IinePointIconProps> = ({
  size = 'sm',
  additionalClassName,
}) => {
  // サイズ指定
  let width = 20
  let height = 19

  switch (size) {
    case 'sm':
      width = 20
      height = 19
      break
    case 'md':
      width = 30
      height = 28.5
      break
  }

  return (
    <div className={`min-w-[16px] ${additionalClassName ?? ''}`}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.99182 0.0852425C5.87688 -0.0655593 6.78451 -0.0158135 7.64779 0.230813C8.51107 0.47744 9.30799 0.914659 9.97982 1.51024L10.0168 1.54324L10.0508 1.51324C10.692 0.950539 11.4458 0.531038 12.262 0.282725C13.0782 0.0344121 13.9379 -0.0370035 14.7838 0.0732426L15.0298 0.109243C16.0961 0.293352 17.0928 0.762399 17.9143 1.46671C18.7358 2.17103 19.3515 3.08439 19.6963 4.11008C20.041 5.13577 20.102 6.2356 19.8727 7.29311C19.6434 8.35062 19.1324 9.32645 18.3938 10.1172L18.2138 10.3022L18.1658 10.3432L10.7158 17.7222C10.5439 17.8924 10.3161 17.9945 10.0747 18.0096C9.83328 18.0246 9.59458 17.9517 9.40282 17.8042L9.30882 17.7222L1.81582 10.3002C1.02204 9.5279 0.457522 8.55092 0.184781 7.47751C-0.0879596 6.4041 -0.058277 5.27614 0.270541 4.21856C0.59936 3.16098 1.21448 2.21504 2.04778 1.48551C2.88109 0.755987 3.90005 0.271339 4.99182 0.0852425Z"
          fill="#027A48"
        />
      </svg>
    </div>
  )
}
